export const COLORS = {
  THEME_COLOR: "#F37032",
  THEME_BACKGROUND: "#F5F5F5",
  FILE_UPLOAD_COLOR: "#047857",
  BANNER_COLOR: "#206DB4",
  WHITE_COLOR: "#FFFFFF",
  BLACK_COLOR: "#000000",
  RATINGS_COLOR: "#FABC07",
  RATINGS_SHADOW_COLOR: "#FAF9F6",
  UPLOAD_BUTTON_COLOR: "#F2F4FF",
  REVIEW_BACK_COLOR: "#d5d9ed",
  PARTNERS_HEADING_COLOR: "#232323",
  PARTNERS_CARD_COLOR: "#FFF6F6",
  CARD_DATE_COLOR: "#000",
  DASHED_DIVIDER_COLOR: "#C9C9C9",
  SOLID_DIVIDER_COLOR: "#CCC",
  ACCORDION_TITLE_COLOR: "#3A3A3A",
  ATTACHMENTS_TEXT_COLOR: "#4D4D4D",
  DETAIL_CARD_TEXT_COLOR: "#1D1D1D",
  NOTIFICATION_HEADING_COLOR: "#1A1F36",
  NOTIFICATION_TEXT_COLOR: "#1A1F36",
  NOTIFICATION_TIME_COLOR: "#A5ACB8",
  NOTIFICATION_DIVIDER_COLOR: "#E4E8EE",
  ATTACHMENT_FILES_COLOR: "#F4F4F4",
  ATTACHMENT_FILES_BORDER_COLOR: "#D0D5DD",
  BORDER_COLOR: "#E5E7EB",
  BADGE_GRAY_COLOR: "#F8F8F8",
  LABEL_TEXT_COLOR: "#A3A3A3",
  PEOPLE_CARD_BG_COLOR: "#F4F4F4",
  TABS_TEXT_COLOR: "#2F2F2F",
  TABS_ACTIVE_BORDER_COLOR: "#FF5D02",
  TOGGLE_ACTIVE_BUTTON_COLOR: "#F3752B",
  TOGGLE_INACTIVE_TEXT_COLOR: "#202630",
  TOGGLE_ACTIVE_TEXT_COLOR: "#FFF",
  ACCORDION_BORDER_COLOR: "#EDEDED",
  WALLET_BADGE_COLOR: "#FFDAC8",
  MODAL_BACK_BUTTON_COLOR: "#64748B",
  PROGRESSBAR_TEXT_COLOR: "#7F7F7F",
  AGENCY_CARD_COLOR: "#F6F6F6",
  APPROVE_TEXT_COLOR: "#21A300",
  REJECT_TEXT_COLOR: "#F00",
  SUCCESS_TOAST_COLOR: "#32CD32",
  ERROR_TOAST_COLOR: "#F41334",
  TRAVEL_PARTNERS_CARD_BGCOLOR: "#F8F8F8",
  REVIEWS_UNDERREVIEW_COLOR: "#F21E1E",
  ERROR_MESSAGE_COLOR: "rgb(220, 38, 38)",
  NOTIFICATION_MODEL_BG_COLOR: "#fcfbfb",
  NOTIFICATION_BORDER_COLOR: "#f6f6f6",
  PACKAGES_CARD_TEXT_COLOR: "#7A7A7A",
  EVENT_BREAKDOWN_AGENDA_COLOR: "#434343",
  PACKAGE_DETAILS_TEXT_COLOR: "#929292",
  ATTENDEES_TYPE_COLOR: "#DCDCDC",
  NO_FILE_ATTACHED_COLOR: "#8D8683",
  PENDING_BADGE_BGCOLOR: "#FFFCB8",
  PENDING_BADGE_TEXT_COLOR: "#514E08",
  APPROVED_BADGE_BGCOLOR: "#AAFF94",
  APPROVED_BADGE_TEXT_cOLOR: "#105100",
  FILTER_TEXT_COLOR: "#636363",
  GRAPH_DATE_COLOR: "#da5028",
  GRAY_COLOR: "#6B7280",
};
